import React from 'react';
import { MessageProps, Icon } from 'semantic-ui-react';

import { styled } from '@modules/common/components/ThemeProvider/utils';

import BaseBanner from './BaseMessage';

type Props = {
  header?: string;
} & MessageProps;

export const getBannerIconStyles = (color: string) => {
  return `.icon-wrapper {
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${color};
    i {
      margin-right: 0;
    }
  }`;
};

const WarningMessage = (props: Props) => {
  return (
    <StyledWarningMessage>
      <div className="icon-wrapper">
        <Icon name="warning" />
      </div>
      <BaseBanner {...props} style={{ width: '100%', marginTop: '0' }}>
        {props.children}
      </BaseBanner>
    </StyledWarningMessage>
  );
};

export default WarningMessage;

const StyledWarningMessage = styled('div')`
  display: flex;
  width: 100%;
  margin-top: 1rem;

  ${getBannerIconStyles('#bf9300')}
`;
